import BaseAngleManager from "../../../../../src/managers/BaseAngleManager";
import { AngleProps, Coord } from "../../../../../src/types/Interface";
import { PINK_ANGLE_COLORS } from "../types/Config";

const pAC = PINK_ANGLE_COLORS;


export default class AngleManager extends BaseAngleManager {
	private cCoord: Coord;
	constructor(cCoord: Coord) {
		const anglePropsArr: AngleProps[] = Array(2)
			.fill(null)
			.map((_, i) => ({ angleColors: { color: pAC[0], textColor: pAC[1] }, smallDistanceOffset: 20, addSmallDis: false }))
		super(anglePropsArr)
		this.cCoord = cCoord;

	}
	draw(chordsPoints: Coord[][], clockwise: boolean = true) {
		chordsPoints.forEach((chordPoints, cPI) => {
			const Points = { curr: chordPoints[1], prev: this.cCoord, next: chordPoints[0] };
			const degree = 90;
			this.drawAngle(this.Angles[cPI], Points, degree, clockwise)
		})
	}
}